<script setup>

import Icon from "../Icon.vue";
import {ICONS} from "../../utils/icons";
import {ref} from "vue";

const hovering = ref(false)
const initialColor = 'initial'
const currentColor = ref(initialColor)

defineProps({
    initialColor: {
        type: String,
        required: false,
        default: 'initial'
    },
    hoverColor: {
        type: String,
        required: false,
        default: 'initial'
    },
    focusColor: {
        type: String,
        required: false,
        default: 'initial'
    },
    title: {
        type: String,
        required: false,
        default: 'Target button'
    },
})
</script>

<template>
    <button class="w-5 h-5" @click="$emit('panToLocation')"
            :title="title"
            @focus="currentColor = focusColor"
            @blur="currentColor = initialColor">
        <Icon :hover-color="hoverColor"
              :focus-color="focusColor"
              :current-color="currentColor"
              :icon="ICONS.target" />
    </button>
</template>
